import React, { useState } from 'react';
import styled from 'styled-components';
import * as CTA from "../../../util/CTA";
import * as color from "../../../util/colors";
import { Text } from '../../../util/typography';
import { NAVIGATION_BREAKPOINT } from '../../../constants/layout';
import { Link } from 'gatsby';

const bp = NAVIGATION_BREAKPOINT;

const UtilityBannerContainer = styled.div`
  // display: flex;
  height: auto;
  width: 100%;
  padding: 8px 20px;
  text-align: center;
  background: ${(props)=>props.brandType === "keytrudahcp" ? "linear-gradient(106deg, #4A0075 1.28%, #5A008F 19.07%, #6A00A8 51.59%, #7C02BB 80.74%, #8215BA 99.08%)" : "linear-gradient(107deg, #2C6D3C 9%, #2C6D3C 44.13%, #36864A 98.1%)"};
  box-shadow: ${(props)=>props.brandType === "keytrudahcp" ? "0px 10px 20px 0px rgba(0, 0, 0, 0.16)" : "unset"};
  transition: background 0.3s ease-out, margin-top 0.3s ease-in-out;
  position: relative;
  z-index: 0;
  pointer-events: auto !important;

  > div:nth-child(2) {


  } 

  > div > a, span {
        text-decoration: underline;
        text-decoration-color: transparent;
        text-decoration-thickness: normal; 
        transition: text-decoration-color 0.4s ease-in-out;
  } 


  &:hover,
  &:active,
  &:focus {
    > div {
      a {
        // text-decoration-color: ${color.white};
        &:after {
          animation-duration: 0.3s;
          animation-name: arrowRight-animation;
          animation-fill-mode: both;
        }
      }
      span {
      text-decoration-color: ${color.white};
      }
    }
  }


  @media (max-width: ${bp}) {
  // height: 56px;
  padding: ${props => props.brandType === "keytrudahcp"  ? "8px 40px" : "8px 20px"};
  }
`;

const PropagationCont = styled.div`
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
z-index: 1;
`;

const StyledTertiaryButton = styled(CTA.TertiaryButton)`
  color: ${color.white};
    width: 100%;
    display: flex;
    justify-content: center;
  &:hover,
  &:active,
  &:focus {
    color: ${color.white};
  }
  &:hover{
   > span{
   text-decoration: underline;
        text-decoration-thickness: normal; 
        transition: text-decoration-color 0.4s ease-in-out;
}
  }

  span {
    padding: 0;
    font-weight: 500 !important;
  }

  &:after {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMC40MSIgaGVpZ2h0PSIxMC4xMyIgZmlsbD0iIzAwNmVhZCI+CiAgICA8cGF0aCBkPSJNNS4zNCAxMC4xM0wzLjkzIDguNzFsMi42NS0yLjY1SDB2LTJoNi41OEwzLjkzIDEuNDEgNS4zNCAwbDUuMDcgNS4wNi01LjA3IDUuMDd6IiBmaWxsPSIjMDA2ZWFkIiAvPgo8L3N2Zz4K), linear-gradient(to right, #ffffff 0%, #ffffff 50%, #ffffff calc(50% + 1px), #ffffff 100%);
  }
`;

const BannerText = styled(Text.Button)`
  color: ${color.white}; 
`;

const UtilityBanner = ({brandType="keytrudahcp",bannerText="Learn about another option ", buttonURL="/qlex/"}) => {
  const [gradientPosition, setGradientPosition] = useState({ x: 100, y: 50 });
  const [isCardHovered, setCardHovered] = useState(false);
  const [recursiveRunning, setRecursiveRunning] = useState(false);

   const handleMouseMove = (e) => {
    e.stopPropagation();
    const rect = e.target.getBoundingClientRect();
    const x = Math.round(((e.clientX - rect.left) / rect.width) * 100);
    const y = ((e.clientY - rect.top) / rect.height) * 100;  

    if(!recursiveRunning){
      if(x > gradientPosition.x){
        recusrvieCalc(x,y,"increment",gradientPosition.x)
  
      }else{
        recusrvieCalc(x,y,"decrement",gradientPosition.x)
      }

    }
   
  }; 

  function recusrvieCalc(x,y,type,currentX){

    if(type == "increment"){
      setTimeout(()=>{

        const changedX = currentX + 1;
        setGradientPosition({
          x: changedX, // Convert mouse position to percentage of the width
          y: y, // Convert mouse position to percentage of the height
        });
        if(x !== currentX){
          setRecursiveRunning(true)
          recusrvieCalc(x,y,"increment",changedX)
        }else{
          setRecursiveRunning(false)
        }
      },0.3)
    }else{
      setTimeout(()=>{
      const changedX = currentX - 1;
      setGradientPosition({
        x: changedX,
        y: y, 
      });
      if(x !== currentX){
        setRecursiveRunning(true)
        recusrvieCalc(x,y,"decrement",changedX)
      }else{
        setRecursiveRunning(false)
      }
    },0.3)
    }
  }
  // const handleMouseEnter = (e) => {
  //   document.body.style.cursor = 'pointer';
  //   setCardHovered(true);
  //   e.stopPropagation();
  // };

  // const handleMouseLeave = () => {
  //   document.body.style.cursor = 'default'; 
  // };

  const gradientStyle = brandType === "keytrudahcp" ? {
    backgroundImage: `radial-gradient(circle at ${gradientPosition.x}% ${gradientPosition.y}%, #8215BA 0%, #7C02BB 40%, #6A00A8 60%, #5A008F 80%, #4A0075 100%)`,
    transition:"background 0.3s linear",
  } : {
    backgroundImage:`linear-gradient(107deg, #2C6D3C 9%, #2C6D3C 44.13%, #36864A 98.1%);`
  }

  return (
    <>
     <UtilityBannerContainer
     
       style={gradientStyle}
      brandType={brandType}
    >
      {/* <PropagationCont /> */}
      <StyledTertiaryButton
          onMouseMove={handleMouseMove}
          // onMouseEnter={handleMouseEnter}
          // onMouseLeave={handleMouseLeave}
          label={bannerText} url={buttonURL}>

      {/* <div>
        <BannerText>{bannerText}</BannerText>
        <StyledTertiaryButton url={buttonURL} />
      </div> */}
      </StyledTertiaryButton>
    </UtilityBannerContainer>
    </>
  );
};

export default UtilityBanner;